import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

import { ActionTypes } from '../../utils/enums';
import { formatThousands } from '../../utils/fillDynamicText';
import { copyFor } from '../../copy/copy';

const getRepFormatAndType = props => {
    let formattingArgs,
        repType = 'representatives';
    if (props.repsEmailed.length === 0) {
        formattingArgs = { recipientName: props.recipientMask };
        repType = 'singleRecipient';
    } else if (props.repsEmailed.length === 1) {
        formattingArgs = { recipientName: props.repsEmailed[0].fullName };
        repType = 'singleRecipient';
    }
    return [formattingArgs, repType];
};

const TitleComponent = props => {
    const [formattingArgs, repType] = getRepFormatAndType(props);
    return (
        <Title>
            <Span>
                {copyFor(
                    'feedback',
                    repType + (props.enableAltEndCardSharing ? 'AltShare' : ''),
                    'email',
                    undefined,
                    formattingArgs
                )}
            </Span>
        </Title>
    );
};

TitleComponent.propTypes = {
    enableAltEndCardSharing: PropTypes.bool,
    recipientMask: PropTypes.string,
    repsEmailed: PropTypes.array
};

const altShareDefaultTwitterFacebookMessage = props => {
    const [formattingArgs, repType] = getRepFormatAndType(props);
    return copyFor(
        'feedback',
        repType + 'AltShareTwitterFacebookMessage',
        'email',
        undefined,
        formattingArgs
    );
};

const EmailAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            fullWidth
            peopleCount={props.peopleCount}
            altShareDefaultTwitterFacebookMessage={altShareDefaultTwitterFacebookMessage(
                props
            )}
            titleComponent={
                <TitleComponent
                    recipientMask={props.recipientMask}
                    repsEmailed={props.repsEmailed}
                    enableAltEndCardSharing={props.enableAltEndCardSharing}
                />
            }
            beforeAdvancing={() => {
                props.setExitingCardProps('email', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

EmailAction.propTypes = {
    enableAltEndCardSharing: PropTypes.bool,
    exitingAction: PropTypes.object.isRequired,
    peopleCount: PropTypes.string.isRequired,
    recipientMask: PropTypes.string,
    repsEmailed: PropTypes.array,
    setExitingCardProps: PropTypes.func.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'email',
            ['/email/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            enableAltEndCardSharing: state.widget.activeAction.enableAltEndCardSharing,
            exitingAction: state.widget.activeAction,
            peopleCount:
                state.email.completeEmail !== undefined
                    ? formatThousands(state.email.completeEmail.endUsersCount)
                    : '',
            recipientMask: state.email.recipientMask,
            repsEmailed: state.email.successInfo.repsEmailed
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Email) return true;

            return next === prev;
        }
    }
)(EmailAction);
